/*
 * File: GetAllCoursePeriods.ts
 * Author: Austin Robinson
 * Date Created: 5/27/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { MinimalUser, privateApi } from 'api';

export interface GetAllCoursePeriodsParams {
  start: string;
  end: string;
}

export type CalendarCoursePeriod = {
  tenant_id: string;
  id: string;
  course_section_id: string;
  start: string;
  end: string;
  open_enrollment: string | null;
  close_enrollment: string | null;
  capacity: number | null;
  deleted: boolean;
  created_at: string | null;
  updated_at: string | null;
  // created_by: string | null;
  // updated_by: string | null;
  course_period_instructors: {
    instructor_user_id: string;
    instructor: {
      tenant_id: string;
      user_id: string;
      calendar_color: string | null;
      created_at: string | null;
      updated_at: string | null;
      user: MinimalUser;
    };
  }[];
  // 'period_enrollments: {
  //   tenant_id: string,
  //   student_user_id: string,
  //   course_period_id: string,
  //   course_enrollment_id: string,
  //   attendance: string | null,
  //   attendance_taken_at: string | null,
  //   attendance_taken_by: string | null,
  //   absence_fee: string | null,
  //   no_permit_fee: string | null,
  //   canceled_at: string | null,
  //   canceled_by: string | null,
  //   cancellation_fee: string | null,
  //   late_cancellation_fee: string | null,
  //   notes: string | null,
  //   private_notes: string | null,
  //   created_by: string | null,
  //   student: {
  //     tenant_id: string,
  //     user_id: string,
  //     permit_num: string | null,
  //     permit_issued: string | null,
  //     permit_expiration: string | null,
  //     permit_restrictions: string | null,
  //     permit_endorsements: string | null,
  //     permit_created_at: string | null,
  //     permit_updated_at: string | null,
  //     medical_conditions: string | null,
  //     high_school: string | null,
  //     user: {
  //       tenant_id: string,
  //       id: string,
  //       title: string | null,
  //       first_name: string | null,
  //       middle_name: string | null,
  //       last_name: string | null,
  //       nickname: string | null,
  //       email: string | null,
  //       date_of_birth: string | null,
  //       sex: string | null,
  //       active: boolean,
  //       created_at: string | null,
  //       updated_at: string | null,
  //       created_by: string | null,
  //       updated_by: string | null,
  //       des_id: string | null,
  //     }
  //   }
  // }[]
  course_section: {
    tenant_id: string;
    id: string;
    course_id: string;
    title: string;
    description: string | null;
    open_enrollment: string | null;
    close_enrollment: string | null;
    capacity: number | null;
    tenant_location_id: string | null;
    course: {
      tenant_id: string;
      id: string;
      course_type: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
      schedule_type: 'self_scheduled' | 'fixed' | 'manual' | 'no_schedule';
      title: string;
      description: string | null;
      created_at: string | null;
      created_by: string | null;
      updated_at: string | null;
      updated_by: string | null;
    };
  };
};

async function getAllCoursePeriods(params: GetAllCoursePeriodsParams | undefined) {
  if (params === undefined) {
    return null;
  }

  const result = await privateApi.get<CalendarCoursePeriod[]>(`${import.meta.env.VITE_API_BASE_URL}/courses/periods`, {
    params: {
      start: params?.start,
      end: params?.end,
    },
  });

  // return the data object
  return result.data;
}

const useGetAllCoursePeriods = createQuery<CalendarCoursePeriod[] | null, GetAllCoursePeriodsParams, Error>({
  queryKey: ['course_periods'],
  fetcher: (variables) => getAllCoursePeriods(variables),
});

export { getAllCoursePeriods, useGetAllCoursePeriods };
